import React from 'react'
import classNames from 'classnames'
import { Base } from '@crossfit/ui'

import style from './style.module.css'

type Props = React.ComponentProps<typeof Base> & {
  variant?: 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'
}

function InnerContent({
  as = 'div',
  className,
  variant = 'medium',
  ...props
}: Props) {
  return (
    <Base
      as={as}
      className={classNames(style.wrapper, className, style[variant])}
      {...props}
    />
  )
}

export default InnerContent
